import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import useNCZICommandProcess from '../../../Hooks/useNCZICommandProcess';
import { TakeOverExamination } from '../../../Commands/TakeOverExamination';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';

interface Props {
	onClose: () => void;
	onConfirm: () => void;
	recordId: string;
	patientIdentifier: string;
}

const TakeOver: React.FC<Props> = props => {
	const { onConfirm, onClose, recordId, patientIdentifier } = props;

	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: (commandId, result) => {
				onConfirm();
			},
		});

	const handleTakeOver = async () => {
		const takeOverCommand = TakeOverExamination({
			patientCode: patientIdentifier!,
			itemId: recordId,
		});

		await processCommand(takeOverCommand);
	};

	if (isProcessing && processingCommandId) {
		return (
			<div>
				<NCZICommandResult
					commandId={processingCommandId}
					handleRetryCommand={handleTakeOver}
				/>
			</div>
		);
	}

	return (
		<div>
			<Text tx={'nczi.examination.takeover.question'} />
			<br />
			<div>
				<Button
					theme={Theme.BLUE}
					title={'nczi.examination.takeover.take'}
					onClick={handleTakeOver}
				/>
			</div>
		</div>
	);
};

export default TakeOver;
